import Vue from "vue";

//API ROOT is set in webpack config

export default {
    get(url, request) {
        return Vue.http
            .get(url, request)
            .then((response) => Promise.resolve(response.body))
            .catch((error) => Promise.reject(error));
    },
    post(url, request) {
        return Vue.http
            .post(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
    patch(url, request) {
        return Vue.http
            .patch(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
    delete(url, request) {
        return Vue.http
            .delete(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
    /* API URIS */
    filtersUri() {
        return API_ROOT + "filters/";
    },
    outfitsUri() {
        return API_ROOT + "outfits";
    },
    productsUri() {
        return API_ROOT + "products/";
    },
    cartUri() {
        return API_ROOT + "cart/";
    },
    credentialsUri() {
        return API_ROOT + "config/credentials/";
    },
    authUri() {
        return API_ROOT + "auth/login/";
    },
    preferencesUri() {
        return API_ROOT + "preferences/";
    },
    accountUri() {
        return API_ROOT + "account/";
    },
    registerUri() {
        return API_ROOT + "account/register/";
    },
    sendResetEmailUri() {
        return API_ROOT + "account/send-reset-email/";
    },
    passwordResetUri() {
        return API_ROOT + "account/reset-password/";
    },
    getCustomerTokenUri() {
        return API_ROOT + "account/get-shopify-access-token";
    },
    agreementsUri() {
        return API_ROOT + "account/agreements";
    },
    stripeUri() {
        return API_ROOT + "stripe/";
    },
    transactionsUri() {
        return API_ROOT + "transactions/";
    },
    socialUri() {
        return API_ROOT + "social/";
    },
    searchUri() {
        return API_ROOT + "products/search/";
    },
    brandsUri() {
        return API_ROOT + "products/brands/";
    },
    collectionsUri() {
        return API_ROOT + "collections/";
    },
};
